module.exports = __webpack_public_path__ + "img/b_select.6f0a92dc.png";